export enum DateFormat {
    DDMMMYYYY = 'DD-MMM-YYYY',
    DDMMYYYY = 'DD-MM-YYYY',
    DDMMMMYY = 'DD-MMMM-YYYY',
    MMDDYYYY = 'MM-DD-YYYY',
    MMMDDYYYY = 'MMM-DD-YYYY',
    MMMMDDYYYY = 'MMMM-DD-YYYY',
    YYYYMMDD = 'YYYY-MM-DD',
    YYYYMMMDD = 'YYYY-MMM-DD',
    YYYYMMMMDD = 'YYYY-MMMM-DD',
}
